"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addGetParamsToLinksAndForms = exports.revealLinksOnAction = exports.onUserActionPromised = exports.onUserAction = void 0;
function onUserAction(callback) {
    const documentEvents = ['touchmove', 'click', 'keydown', 'mousemove'];
    function handler(e) {
        documentEvents.forEach(event => document.body.removeEventListener(event, handler));
        callback(e);
    }
    documentEvents.forEach(event => document.body.addEventListener(event, handler));
}
exports.onUserAction = onUserAction;
function onUserActionPromised() {
    return new Promise(resolve => onUserAction(resolve));
}
exports.onUserActionPromised = onUserActionPromised;
function revealLinksOnAction(options) {
    const { onLinksReady, editLink } = options;
    const linksLikeItems = document.querySelectorAll('span[data-secret]');
    let linkToRedirect = null;
    onUserAction(reveal);
    function reveal(e) {
        var _a;
        const secret = (_a = e.target.dataset) === null || _a === void 0 ? void 0 : _a.secret;
        const isClick = e.type === 'click';
        linksLikeItems.forEach((link) => handleSecret(link, secret));
        onLinksReady === null || onLinksReady === void 0 ? void 0 : onLinksReady();
        if (linkToRedirect && isClick)
            location.assign(linkToRedirect.href);
    }
    function parseSecret(secret) {
        return secret
            .replace('*', 'https://')
            .replace(/|/g, '.')
            .replace(/\$/g, '/');
    }
    function handleSecret(linkLikeItem, targetSecret) {
        const attrs = linkLikeItem.attributes;
        const html = linkLikeItem.innerHTML;
        const link = document.createElement('a');
        for (const attr of attrs)
            link.setAttribute(attr.name, attr.value);
        const secret = linkLikeItem.dataset.secret;
        let href = parseSecret(secret);
        href = editLink
            ? editLink(href)
            : href;
        link.setAttribute('href', href);
        link.removeAttribute('data-secret');
        link.innerHTML = html;
        linkLikeItem.replaceWith(link);
        if (targetSecret === secret)
            linkToRedirect = link;
    }
}
exports.revealLinksOnAction = revealLinksOnAction;
function addGetParamsToLinksAndForms(params) {
    let query = '';
    if (typeof params === 'string') {
        query = params;
    }
    else {
        for (const key in params) {
            if (query)
                query += '&';
            query += `${key}=${params[key]}`;
        }
    }
    const isDotCom = document.location.origin.includes('.com');
    const studybayServiceLinksSelector = `
        a[href*="loop.studybay"],
        a[href*="studybay.${isDotCom ? 'app' : 'com'}"],
        a[href*="login/"],
        a[href*="reg/"],
        a[href*="studybayhelp"],
        a[data-first-touch]
    `;
    const serviceLinks = Array.from(document.querySelectorAll(studybayServiceLinksSelector));
    const serviceForms = Array.from(document.querySelectorAll('form[action]'));
    const isOurProjectRegEx = /(^https?:\/\/)(?=studybay|mystudybay|dev\d{0,3}\.|test.*\.(my)?studybay|loop.studybay)/;
    serviceForms.forEach(updateUrl('action'));
    serviceLinks
        .filter(link => isOurProjectRegEx.test(link.href))
        .forEach(updateUrl('href'));
    function updateUrl(attribute) {
        return function (element) {
            const currentLink = element.getAttribute(attribute);
            const hasQuery = /\/?\?/.test(currentLink);
            const newLink = `${currentLink}${hasQuery ? '&' : '?'}${query}`;
            element.setAttribute(attribute, newLink);
        };
    }
}
exports.addGetParamsToLinksAndForms = addGetParamsToLinksAndForms;
